import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";

console.log("Hello World!")

@Component({
  selector: 'PflegegruppeSelect',
  templateUrl: './PflegegruppeSelect.html',
  styleUrl: './PflegegruppeSelect.css',
  imports: [
    CommonModule,  
    FormsModule
  ],
})
export class PflegegruppeSelect {

  Data = [
    { key: 51, Bezeichnung: "PHM51" },
    { key: 52, Bezeichnung: "HNR" },
    { key: 54, Bezeichnung: "PHM" },
  ]

  @Input() Pflegegruppe: number = 52;
  @Output() PflegegruppeChange = new EventEmitter<number>();

  onStatusChange(value: string) {
    
    // Emit the value to the parent
    this.PflegegruppeChange.emit(Number(value));
  }
}
